import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import { Icon } from '../icons';

import { DownloadPdfButtonProps } from './types';
import { PrintToolDialog } from './print-tool-dialog';

export const DownloadPdfButton = ({ disabled }: DownloadPdfButtonProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(['dashboard']);

  const LockIcon = disabled ? Icon.LockOn : Icon.LockOff;

  return (
    <>
      <button
        tabIndex={0}
        disabled={disabled}
        onClick={() => setOpen(true)}
        className={twMerge(
          'relative flex w-full items-center gap-2 rounded-2xl p-3 md:justify-center md:gap-4 md:rounded-3xl md:px-5 md:py-2',
          disabled
            ? 'text-black-primary bg-mauve-light'
            : 'text-white-primary bg-mauve-primary hover:bg-mauve-primary/80 cursor-pointer transition-colors'
        )}
      >
        <div
          className={twMerge(
            'bg-white-primary flex h-10 w-10 shrink-0 items-center justify-center rounded-lg md:h-16 md:w-16 md:rounded-2xl',
            disabled
              ? 'opacity-60'
              : 'shadow-black-primary/10 shadow-[0px_4px_8px_0px]'
          )}
        >
          <Icon.PrintTool className="text-mauve-primary h-6 w-6 md:h-12 md:w-12" />
        </div>
        <span className="text-left font-medium max-md:flex-1 md:text-center md:text-2xl md:text-(length:--h2-size) md:leading-(--h2-line) md:font-semibold">
          {t('printTool')}
        </span>
        <div className="bg-white-primary flex h-8 w-8 shrink-0 items-center justify-center rounded-full md:absolute md:top-1/2 md:right-3.5 md:h-10 md:w-10 md:-translate-y-1/2">
          <LockIcon className="[&_path]:fill-mauve-primary h-4 w-4 md:h-6 md:w-6" />
        </div>
      </button>
      <PrintToolDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
